<template>
  <div>
    <b-overlay :show="loading" opacity="0.99">
      <div class="v-clean p-5 text-center" v-show="data.length == 0">
        <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
      </div>
      <div v-if="!exist" class="text-center mt-2">
        <v-btn
          @click="deleteLot"
          :loading="loading"
          :disabled="loading"
          class="btn-delete"
        >
          EXCLUIR LOTE
        </v-btn>
      </div>
      <v-data-table
        v-show="data.length > 0"
        :headers="headers"
        :items="data"
        item-key="id"
        :footer-props="{
          'items-per-page-options': [25, 50, 75, 100],
          'items-per-page-text': 'Mostrar',
        }"
      >
        <template #[`item.owner`]="{ item }">
          {{ item.owner }} - {{ item.stock_group_name }}
        </template>
      </v-data-table>
      <errors-messages :errors="errors" />
    </b-overlay>
  </div>
</template>

<script>
import ErrorsMessages from "../../../Components/ErrorsMessages.vue";

import api from "../../../../services/api";
import toast from "../../../../lib/ToastNotification";

export default {
  name: "ViewLotOwner",

  components: {
    ErrorsMessages,
  },

  props: {
    objLot: [Object, null],
  },

  data() {
    return {
      headers: [{ text: "DONO", value: "owner" }],

      data: [],
      exist: true,
      errors: [],
      loading: false,
    };
  },

  created() {
    this.errors = [];
    this.get();
  },

  methods: {
    async get() {
      try {
        this.loading = true;

        let {
          objLot: { id },
        } = this;

        const params = { id };

        const response = await api.get("/rest-home/stock/items/lot/owner", {
          params,
        });

        const { error, errors, data, exist } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.data = data;
          this.exist = exist;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },

    async deleteLot() {
      try {
        this.loading = true;

        let {
          objLot: { id },
        } = this;

        const data = { id };

        const response = await api.delete("/rest-home/stock/items/lot", {
          data,
        });

        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.$bvModal.hide(`view_lot_owner-${id}`);
          this.$emit("deleted");
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style>
</style>